import React,{ Component } from 'react';
import {Row, Col, Button, ButtonGroup, Alert, Checkbox} from 'react-bootstrap';
import FieldGroup from '../../../../components/FieldGroup';
import SelectWrap from '../../../../components/SelectWrap';
import { handleFieldChange, handleCheckboxChange } from "../../../../Utils";
import countriesObj from "../../../../data/countries";

const countriesOptions = Object.assign({ all: 'All' }, countriesObj);

class Filters extends Component {
    constructor(props) {
        super(props);

        this.state = {
            day: '',
            hour: '',
            affid: null,
            country: null,
            subid: null,
        };

        this.handleFieldChange = handleFieldChange.bind(this);
        this.handleCheckboxChange = handleCheckboxChange.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
    }

    handleFormSubmit(type) {
        const isValid = this.validateForm(type);
        const filters = Object.assign({}, this.state);

        if(filters.compareDay) filters.compare = 1;

        if(isValid) {
            if (type === "all") {
                if (!window.confirm(`Are you sure to fetch data for "${filters.day} ${filters.hourFrom}-${filters.hourTo}"`)) return false;
            }

            this.props.onSubmit(filters, type);
        }
    }

    validateForm(type) {
        const { day, hour, hourFrom, hourTo, compareDay, compareHourFrom, compareHourTo, ...filters } = this.state;

        let alert = null;

        if(!day) alert = 'Please set Day';

        console.log(filters )

        if (type === "all") {
            if (!hourFrom || !hourTo) alert = "Select hours first"
            else if (hourFrom < 0) alert = "Hour must be at least 0"
            else if (hourTo > 23) alert = "Hour must be lower than 23"
            else if (!Object.values(filters).some((x) => x !== null)) alert = "Select one of the filters: subid, affid, country"
        }

        this.setState({ alert });

        return !alert;
    }

    getAlert() {
        const { alert } = this.state;

        if(alert) return <Alert bsStyle={'danger'}>{alert}</Alert>
    }

    render() {
        return (
            <form>
                {this.getAlert()}
                <Row>
                    <Col lg={2}>
                        <FieldGroup
                            type="date"
                            name="day"
                            label="Day:"
                            onChange={this.handleFieldChange}
                            value={this.state.day}
                        />
                    </Col>
                    <Col lg={2}>
                        <FieldGroup
                            type="number"
                            name="hourFrom"
                            label="Hour From:"
                            min={0}
                            max={23}
                            onChange={this.handleFieldChange}
                            value={this.state.hourFrom}
                        />
                    </Col>
                    <Col lg={2}>
                        <FieldGroup
                            type="number"
                            name="hourTo"
                            label="Hour To:"
                            min={0}
                            max={23}
                            onChange={this.handleFieldChange}
                            value={this.state.hourTo}
                        />
                    </Col>
                    <Col lg={2}>
                        <FieldGroup
                            type="date"
                            name="compareDay"
                            label="Compare Day:"
                            onChange={this.handleFieldChange}
                            value={this.state.compareDay}
                        />
                    </Col>
                    <Col lg={2}>
                        <FieldGroup
                            type="number"
                            name="compareHourFrom"
                            label="Cmp. Hour From:"
                            min={0}
                            max={23}
                            onChange={this.handleFieldChange}
                            value={this.state.compareHourFrom}
                        />
                    </Col>
                    <Col lg={2}>
                        <FieldGroup
                            type="number"
                            name="compareHourTo"
                            label="Cmp. Hour To:"
                            min={0}
                            max={23}
                            onChange={this.handleFieldChange}
                            value={this.state.compareHourTo}
                        />
                    </Col>

                </Row>
                <Row>
                    <Col lg={3}>
                        <SelectWrap
                            values={this.props.affidValues}
                            label="Affid:"
                            name="affid"
                            onChange={this.handleFieldChange}
                            value={this.state.affid}
                            multi
                            required
                        />
                    </Col>
                    <Col lg={3}>
                        <SelectWrap
                            values={this.props.subidValues}
                            label="Subid:"
                            name="subid"
                            onChange={this.handleFieldChange}
                            value={this.state.subid}
                            multi
                            required
                        />
                    </Col>
                    <Col lg={3}>
                        <SelectWrap
                            values={countriesOptions}
                            label="Countries:"
                            name="country"
                            onChange={this.handleFieldChange}
                            value={this.state.country}
                            multi
                            required
                        />
                    </Col>
                    <Col lg={3}>
                        <SelectWrap
                            values={this.props.partnerValues}
                            label="Partner:"
                            name="partner"
                            onChange={this.handleFieldChange}
                            value={this.state.partner}
                        />
                    </Col>
                </Row>

                <ButtonGroup>
                    <Button type="button" bsStyle="info" className="m-b-15 m-r-15" onClick={() => this.handleFormSubmit('affid')}>Load Affid</Button>
                    <Button type="button" bsStyle="info" className="m-b-15 m-r-15" onClick={() => this.handleFormSubmit('subid')}>Load Subid</Button>
                    <Button type="button" bsStyle="info" className="m-b-15 m-r-15" onClick={() => this.handleFormSubmit('country')}>Load Country</Button>
                    <Button type="button" bsStyle="info" className="m-b-15 m-r-15" onClick={() => this.handleFormSubmit('all')}>Load All</Button>
                    <Button type="button" bsStyle="info" className="m-b-15" onClick={() => this.handleFormSubmit('')}>Load Report</Button>
                </ButtonGroup>
            </form>
        );
    }
}

export default Filters;



// WEBPACK FOOTER //
// ./src/scenes/AdkHourlyV2/components/Form/index.js